export const layoutEn = {
    footer: {
        left: `Copyright ${new Date().getFullYear()}`,
        right: 'SmarterClick'
    }
};

export const layoutNl = {};
